import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { DIAN_SHANG_YE_WU_API_BASE } from "../config/api";
import form_data from "./formData";

const DianShangYeWuApi = createApi({
    reducerPath: 'DianShangYeWuApi',
    baseQuery: fetchBaseQuery({
        baseUrl: DIAN_SHANG_YE_WU_API_BASE,
        credentials: 'include' // 确保发送和接收 cookies（包括会话 cookie）
    }),
    tagTypes:['pingtaiType','baozhangdan'],
    endpoints(build) {
        return {            
            //新增平台类型
            pingtaiTypeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/pingtaiTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['pingtaiType'],
            }),         
            //修改保存平台类型
            pingtaiTypeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/pingtaiTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['pingtaiType'],
            }),         
            //查询平台类型
            pingtaiTypeList: build.query({
                query(user) {                    
                    return {
                        url: '/pingtaiTypeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['pingtaiType'],
            }),         
            //修改平台类型
            pingtaiTypeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/pingtaiTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['pingtaiType'],
            }),          
            //删除平台类型
            pingtaiTypeDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/pingtaiTypeDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['pingtaiType'],
            }),  
            //新增产品类型
            chanpinTypeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/chanpinTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['chanpinType'],
            }),         
            //修改保存产品类型
            chanpinTypeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/chanpinTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['chanpinType'],
            }),         
            //查询产品类型
            chanpinTypeList: build.query({
                query(user) {                    
                    return {
                        url: '/chanpinTypeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['chanpinType'],
            }),         
            //修改产品类型
            chanpinTypeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/chanpinTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['chanpinType'],
            }),          
            //删除产品类型
            chanpinTypeDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/chanpinTypeDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['chanpinType'],
            }),  
            //新增团队报账单
            baozhangdanAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/baozhangdanAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),         
            //修改保存团队报账单
            baozhangdanUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/baozhangdanUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),         
            //修改团队报账单提交状态
            baozhangdanZTXG: build.mutation({
                query(user) {                    
                    return {
                        url: '/baozhangdanZTXG',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),         
            //财务修改团队报账单提交状态
            baozhangdanCWCH: build.mutation({
                query(user) {                    
                    return {
                        url: '/baozhangdanCWCH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),         
            //查询团队报账单
            baozhangdanList: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan'],
            }),         
                   
            //修改团队报账单
            baozhangdanUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan'],
            }),          
            //删除团队报账单
            baozhangdanDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/baozhangdanDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),  
            //审核团队报账单
            shouzhiSH: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiSH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),  
            //删除审核团队报账单
            shouzhiDelUidSH: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiDelUidSH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),  
            //取消审核团队报账单
            shouzhiDelSH: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiDelSH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['baozhangdan'],
            }),  
            //新增团队报账单收支
            shouzhiAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shouzhi','baozhangdan'],
            }),         
            //修改保存团队报账单收支
            shouzhiUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shouzhi','baozhangdan'],
            }),         
            //查询团队报账单收支
            shouzhiList: build.query({
                query(user) {                    
                    return {
                        url: '/shouzhiList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi'],
            }),         
            //修改团队报账单收支
            shouzhiUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shouzhiUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi'],
            }),          
            //删除团队报账单收支
            shouzhiDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shouzhi','baozhangdan'],
            }),  
            //删除全部费用报销收支
            shouzhiAllDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiAllDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shouzhi','baozhangdan'],
            }),  
            //批量修改收支的账单信息
            shouzhiAllUpdateYSYF: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiAllUpdateYSYF',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shouzhi',],
            }),  
            //删除收支的账单信息
            shouzhiDelYSYF: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiDelYSYF',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shouzhi',],
            }),  
            //批量删除收支的账单信息
            shouzhiAllDelYSYF: build.mutation({
                query(user) {                    
                    return {
                        url: '/shouzhiAllDelYSYF',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shouzhi',],
            }),  
            //电商业务平台利润统计
            pingtaiTypeMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/pingtaiTypeMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //电商业务客服利润统计
            dsbzdKFMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/dsbzdKFMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //电商业务计调利润统计
            dsbzdJDMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/dsbzdJDMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //电商业务主播利润统计
            dsbzdZBMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/dsbzdZBMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //电商业务产品类型利润统计
            chanpinTypeMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/chanpinTypeMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //电商业务月度利润统计
            dsbzdMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/dsbzdMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //审核月度统计表
            dsbzdSHMonthTJ: build.query({
                query(user) {                    
                    return {
                        url: '/dsbzdSHMonthTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //网店利润（按创建日期）
            pingtaiCreateDateLiRun: build.query({                                
                query(user) {                    
                    return {
                        url: '/pingtaiCreateDateLiRun',                                                
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
           
            //产品利润（按创建日期）
            chanpinCreateDateLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/chanpinCreateDateLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //计调利润（按创建日期）
            jidiaoCreateDateLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/jidiaoCreateDateLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //客服利润（按创建日期）
            kefuCreateDateLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/kefuCreateDateLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //主播利润（按创建日期）
            zhuboCreateDateLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/zhuboCreateDateLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //网店利润趋势图
            getWDMonthLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/getWDMonthLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //产品利润趋势图
            getCPMonthLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/getCPMonthLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //客服利润趋势图
            getKFMonthLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/getKFMonthLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //计调利润趋势图
            getJDMonthLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/getJDMonthLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //主播利润趋势图
            getZBMonthLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/getZBMonthLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan']
            }),  
            //获取费用报销新增
            baozhangdanUidList: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanUidList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //获取费用报销审核
            baozhangdanSHList: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanSHList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //获取费用报销网店
            baozhangdanPTList: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanPTList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //获取费用报销客服
            baozhangdanKFList: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanKFList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //获取费用报销计调
            baozhangdanJDList: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanJDList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //获取费用报销主播
            baozhangdanZBList: build.query({
                query(user) {                    
                    return {
                        url: '/baozhangdanZBList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),  
            //新增账单
            yingshouyingfuAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/yingshouyingfuAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yingshouyingfu'],
            }),         
            //修改保存账单
            yingshouyingfuUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/yingshouyingfuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yingshouyingfu'],
            }),         
            //查询账单
            yingshouyingfuList: build.query({
                query(user) {                    
                    return {
                        url: '/yingshouyingfuList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yingshouyingfu'],
            }),         
            //修改账单
            yingshouyingfuUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/yingshouyingfuUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yingshouyingfu'],
            }),          
            //删除账单
            yingshouyingfuDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/yingshouyingfuDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yingshouyingfu'],
            }),  
            //获取利润表
            getLiRun: build.query({
                query(user) {                    
                    return {
                        url: '/getLiRun',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shouzhi','baozhangdan'],
            }),  
            //新增银行
            bankAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/bankAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['bank'],
            }),  
            //修改保存银行
            bankUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/bankUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['bank'],
            }),  
            //删除银行
            bankDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/bankDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['bank'],
            }),  
            //修改银行
            bankUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/bankUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['bank'],
            }),  
            //银行列表
            bankList: build.query({
                query(user) {                    
                    return {
                        url: '/bankList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['bank'],
            }),  
            //新增收款单
            dingdanshouruAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru','baozhangdan'],
            }),  
            //修改保存收款单
            dingdanshouruUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru','baozhangdan'],
            }),  
            //删除收款单
            dingdanshouruDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru','baozhangdan'],
            }),  
            //修改收款单状态
            dingdanshouruZTXG: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruZTXG',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru','baozhangdan'],
            }),  
            //财务修改收款单
            dingdanshouruCWCH: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruCWCH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru','baozhangdan'],
            }),  
            //财务修改收款单支付类型
            dingdanshouruZFLX: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruZFLX',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru','baozhangdan'],
            }),  
            //修改收款单
            dingdanshouruUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/dingdanshouruUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['dingdanshouru'],
            }),  
            //收款单列表
            dingdanshouruList: build.query({
                query(user) {                    
                    return {
                        url: '/dingdanshouruList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['dingdanshouru'],
            }),  
            //收款单审批日志
            SKspList: build.query({
                query(user) {                    
                    return {
                        url: '/SKspList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['SKsp'],
            }),  
            //收款单提交
            SKtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKsp','dingdanshouru','baozhangdan'],
            }),  
            //收款单新增提交
            SKaddtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKaddtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKsp','dingdanshouru','baozhangdan'],
            }),  
            //收款单审批同意
            SKtongyi: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKtongyi',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKsp','dingdanshouru','baozhangdan'],
            }),  
            //收款单审批驳回
            SKbohui: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKbohui',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKsp','dingdanshouru','baozhangdan'],
            }),  
            //收款单抄送
            SKchaosong: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKchaosong',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKsp','dingdanshouru','baozhangdan'],
            }),  
            //收款单修改审批说明
            SKupdatecontent: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKupdatecontent',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKsp','dingdanshouru','baozhangdan'],
            }),  
            //新增付款单
            dingdanzhichuAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu','baozhangdan'],
            }),  
            //修改保存付款单
            dingdanzhichuUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu','baozhangdan'],
            }),  
            //删除付款单
            dingdanzhichuDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu','baozhangdan'],
            }),  
            //修改付款单状态
            dingdanzhichuZTXG: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuZTXG',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu','baozhangdan'],
            }), 
            //财务修改付款单
            dingdanzhichuCWCH: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuCWCH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu','baozhangdan'],
            }),   
            //财务修改收款单支付类型
            dingdanzhichuZFLX: build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuZFLX',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu','baozhangdan'],
            }),  
            //修改付款单
            dingdanzhichuUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['dingdanzhichu'],
            }),  
            //付款单列表
            dingdanzhichuList: build.query({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['dingdanzhichu'],
            }),  
            //付款单审批日志列表
            FKspList: build.query({
                query(user) {                    
                    return {
                        url: '/FKspList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['FKsp'],
            }),  
            //付款单新增提交
            FKaddtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKaddtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKsp','dingdanzhichu','baozhangdan'],
            }),  
            //付款单提交
            FKtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKsp','dingdanzhichu','baozhangdan'],
            }), 
            //付款单审批同意
            FKtongyi: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKtongyi',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKsp','dingdanzhichu','baozhangdan'],
            }),  
            //付款单审批驳回
            FKbohui: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKbohui',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKsp','dingdanzhichu','baozhangdan'],
            }),  
            //付款单抄送
            FKchaosong: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKchaosong',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKsp','dingdanzhichu','baozhangdan'],
            }),  
            //付款单修改审批说明
            FKupdatecontent: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKupdatecontent',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKsp','dingdanzhichu','baozhangdan'],
            }),  
            //获取报账单常用信息
            getCYlist: build.query({
                query(user) {                    
                    return {
                        url: '/getCYlist',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan'],
            }),  
            //新增部门
            bumenAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/bumenAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['bumen'],
            }),  
            //修改保存部门
            bumenUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/bumenUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['bumen'],
            }),  
            //删除部门
            bumenDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/bumenDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['bumen'],
            }),  
            //修改部门
            bumenUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/bumenUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['bumen'],
            }),  
            //部门列表
            bumenList: build.query({
                query(user) {                    
                    return {
                        url: '/bumenList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['bumen'],
            }),  
            //新增客户
            kehuAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehuAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehu'],
            }),  
            //批量新增客户
            csvFile: build.mutation({
                query(user) {                    
                    return {
                        url: '/csvFile',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehu'],
            }),
            //修改保存客户
            kehuUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehu'],
            }),  
            //删除客户
            kehuDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehuDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehu'],
            }),  
            //修改客户
            kehuUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/kehuUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehu'],
            }),  
            //客户列表
            kehuList: build.query({
                query(user) {                    
                    return {
                        url: '/kehuList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehu'],
            }),  
            //新增客户类型
            kehulxAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehulxAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehulx'],
            }),  
            //修改保存客户类型
            kehulxUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehulxUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehulx'],
            }),  
            //删除客户类型
            kehulxDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehulxDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehulx'],
            }),  
            //修改客户类型
            kehulxUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/kehulxUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehulx'],
            }),  
            //客户类型列表
            kehulxList: build.query({
                query(user) {                    
                    return {
                        url: '/kehulxList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehulx'],
            }),  
            //新增客户银行账户
            kehuyhzhAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehuyhzhAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehuyhzh'],
            }),  
            //修改保存客户银行账户
            kehuyhzhUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehuyhzhUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehuyhzh'],
            }),  
            //删除客户银行账户
            kehuyhzhDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehuyhzhDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehuyhzh'],
            }),  
            //修改客户银行账户
            kehuyhzhUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/kehuyhzhUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehuyhzh'],
            }),  
            //客户银行账户列表
            kehuyhzhList: build.query({
                query(user) {                    
                    return {
                        url: '/kehuyhzhList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehuyhzh'],
            }),  
            //新增客户对接人
            khlxrAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/khlxrAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['khlxr'],
            }),  
            //修改保存客户对接人
            khlxrUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/khlxrUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['khlxr'],
            }),  
            //删除客户对接人
            khlxrDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/khlxrDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['khlxr'],
            }),  
            //修改客户对接人
            khlxrUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/khlxrUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['khlxr'],
            }),  
            //客户对接人列表
            khlxrList: build.query({
                query(user) {                    
                    return {
                        url: '/khlxrList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['khlxr'],
            }),  
            //新增客户开票信息
            kehukpxxAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehukpxxAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehukpxx'],
            }),  
            //修改保存客户开票信息
            kehukpxxUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehukpxxUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehukpxx'],
            }),  
            //删除客户开票信息
            kehukpxxDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/kehukpxxDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kehukpxx'],
            }),  
            //修改客户开票信息
            kehukpxxUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/kehukpxxUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehukpxx'],
            }),  
            //客户开票信息列表
            kehukpxxList: build.query({
                query(user) {                    
                    return {
                        url: '/kehukpxxList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehukpxx'],
            }),  
            //新增收款类型
            shoukuanlxAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shoukuanlxAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shoukuanlx'],
            }),  
            //修改保存收款类型
            shoukuanlxUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shoukuanlxUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shoukuanlx'],
            }),  
            //删除收款类型
            shoukuanlxDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shoukuanlxDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shoukuanlx'],
            }),  
            //修改收款类型
            shoukuanlxUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shoukuanlxUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shoukuanlx'],
            }),  
            //收款类型列表
            shoukuanlxList: build.query({
                query(user) {                    
                    return {
                        url: '/shoukuanlxList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shoukuanlx'],
            }),  
            //新增付款类型
            fukuanlxAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/fukuanlxAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fukuanlx'],
            }),  
            //修改保存付款类型
            fukuanlxUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/fukuanlxUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fukuanlx'],
            }),  
            //删除付款类型
            fukuanlxDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/fukuanlxDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fukuanlx'],
            }),  
            //修改付款类型
            fukuanlxUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/fukuanlxUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['fukuanlx'],
            }),  
            //付款类型列表
            fukuanlxList: build.query({
                query(user) {                    
                    return {
                        url: '/fukuanlxList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['fukuanlx'],
            }),  
            //新增费用类型
            feiyongTypeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyongType'],
            }),  
            //修改保存费用类型
            feiyongTypeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyongType'],
            }),  
            //删除费用类型
            feiyongTypeDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongTypeDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyongType'],
            }),  
            //修改费用类型
            feiyongTypeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyongType'],
            }),  
            //费用类型列表
            feiyongTypeList: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongTypeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyongType'],
            }),  
            //新增费用
            feiyongAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong','baozhangdan'],
            }),  
            //修改保存费用
            feiyongUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong','baozhangdan'],
            }),  
            //删除费用
            feiyongDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong','baozhangdan'],
            }),  
            //修改费用状态
            feiyongZTXG: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongZTXG',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong','baozhangdan'],
            }),  
            //财务修改费用单
            feiyongCWCH: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongCWCH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong','baozhangdan'],
            }),  
            //财务修改费用单支付类型
            feiyongZFLX: build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongZFLX',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong','baozhangdan'],
            }),  
            //修改费用
            feiyongUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),  
            //费用列表
            feiyongList: build.query({
                query(user) {                    
                    return {
                        url: '/feiyongList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['feiyong'],
            }),             
            //费用单审批日志列表
            FYspList: build.query({
                query(user) {                    
                    return {
                        url: '/FYspList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['FYsp'],
            }),
            //费用单抄送
            FYchaosong: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYchaosong',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYsp','feiyong','baozhangdan'],
            }),  
            //费用单同意审批
            FYtongyi: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYtongyi',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYsp','feiyong','baozhangdan'],
            }),  
            //费用单驳回审批
            FYbohui: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYbohui',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYsp','feiyong','baozhangdan'],
            }),  
            //费用单修改审批说明
            FYupdatecontent: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYupdatecontent',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYsp','feiyong','baozhangdan'],
            }),  
            //费用单提交
            FYtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYsp','feiyong','baozhangdan'],
            }),  
            //费用单新增提交
            FYaddtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYaddtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYsp','feiyong','baozhangdan'],
            }),  
            
            //新增借款类型
            jiekuanlxAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanlxAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuanlx'],
            }),  
            //修改保存借款类型
            jiekuanlxUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanlxUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuanlx'],
            }),  
            //删除借款类型
            jiekuanlxDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanlxDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuanlx'],
            }),  
            //修改借款类型
            jiekuanlxUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/jiekuanlxUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['jiekuanlx'],
            }),  
            //借款类型列表
            jiekuanlxList: build.query({
                query(user) {                    
                    return {
                        url: '/jiekuanlxList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['jiekuanlx'],
            }),  
            //新增借款单
            jiekuanAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan'],
            }),  
            //修改保存借款单
            jiekuanUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan'],
            }),  
            //删除借款单
            jiekuanDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan'],
            }),  
            //修改借款单状态
            jiekuanZTXG: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanZTXG',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan'],
            }),  
            //财务修改借款单
            jiekuanCWCH: build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanCWCH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan'],
            }),  
            //修改借款单
            jiekuanUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/jiekuanUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['jiekuan'],
            }),  
            //借款单列表
            jiekuanList: build.query({
                query(user) {                    
                    return {
                        url: '/jiekuanList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['jiekuan'],
            }),  
            //新增提交借款单
            JKaddtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKaddtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan','JKsp'],
            }),  
            //同意审批借款单
            JKtongyi: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKtongyi',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan','JKsp'],
            }), 

            //抄送借款单
            JKchaosong: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKchaosong',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan','JKsp'],
            }),  
            //驳回审批借款单
            JKbohui: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKbohui',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan','JKsp'],
            }),  
            //修改借款单审批备注
            JKupdatecontent: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKupdatecontent',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan','JKsp'],
            }),  
            //提交借款单
            JKtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan','baozhangdan','JKsp'],
            }),  
            //借款单审批日志列表
            JKspList: build.query({
                query(user) {                    
                    return {
                        url: '/JKspList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['JKsp'],
            }),
            //新增发票类型
            kaipiaolxAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaolxAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaolx'],
            }),  
            //修改保存发票类型
            kaipiaolxUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaolxUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaolx'],
            }),  
            //删除发票类型
            kaipiaolxDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaolxDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaolx'],
            }),  
            //修改发票类型
            kaipiaolxUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/kaipiaolxUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kaipiaolx'],
            }),  
            //发票类型列表
            kaipiaolxList: build.query({
                query(user) {                    
                    return {
                        url: '/kaipiaolxList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kaipiaolx'],
            }),  
            //新增开票申请
            kaipiaodanAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaodanAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaodan','baozhangdan','dingdanshouru'],
            }),  
            //修改保存开票申请
            kaipiaodanUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaodanUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaodan','baozhangdan'],
            }),  
            //删除开票申请
            kaipiaodanDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaodanDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaodan','baozhangdan','dingdanshouru'],
            }),  
            //修改开票申请状态
            kaipiaodanZTXG: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaodanZTXG',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaodan','baozhangdan'],
            }), 
            //财务修改开票申请
            kaipiaodanCWCH: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaodanCWCH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaodan','baozhangdan'],
            }),  
            //开票申请上传发票
            kaipiaodanSC: build.mutation({
                query(user) {                    
                    return {
                        url: '/kaipiaodanSC',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['kaipiaodan'],
            }),  
            //修改开票申请
            kaipiaodanUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/kaipiaodanUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kaipiaodan'],
            }),  
            //开票申请列表
            kaipiaodanList: build.query({
                query(user) {                    
                    return {
                        url: '/kaipiaodanList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kaipiaodan'],
            }),  
            //开票申请审批日志
            KPSQspList: build.query({
                query(user) {                    
                    return {
                        url: '/KPSQspList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['KPSQsp','kaipiaodan'],
            }),
            //开票申请提交
            KPSQtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQsp','kaipiaodan'],
            }),
            //开票申请新增提交
            KPSQaddtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQaddtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQsp','kaipiaodan','dingdanshouru'],
            }),
            //开票申请审批同意
            KPSQtongyi: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQtongyi',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQsp','kaipiaodan'],
            }),
            //开票申请审批驳回
            KPSQbohui: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQbohui',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQsp','kaipiaodan'],
            }),
            //开票申请抄送
            KPSQchaosong: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQchaosong',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQsp','kaipiaodan'],
            }),
            //开票申请修改审批内容
            KPSQupdatecontent: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQupdatecontent',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQsp','kaipiaodan'],
            }),
            //新增月度日志
            yueduAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/yueduAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yuedu','kaipiaodan','baozhangdan','jiekuan','feiyong','dingdanshouru','dingdanzhichu'],
            }),  
            //删除月度日志
            yueduDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/yueduDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yuedu'],
            }),  
            //月度日志列表
            yueduList: build.query({
                query(user) {                    
                    return {
                        url: '/yueduList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yuedu'],
            }), 
            //新增企业银行账户
            qiyeyhzhAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeyhzhAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiyeyhzh'],
            }),  
            //修改保存企业银行账户
            qiyeyhzhUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeyhzhUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiyeyhzh'],
            }),  
            //删除企业银行账户
            qiyeyhzhDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeyhzhDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiyeyhzh'],
            }),  
            //修改企业银行账户
            qiyeyhzhUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeyhzhUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiyeyhzh'],
            }),  
            //企业银行账户列表
            qiyeyhzhList: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeyhzhList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiyeyhzh'],
            }),   
            //新增发票日志
            fpAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/fpAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fp' ],
            }),  
            //修改保存发票日志
            fpUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/fpUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fp' ],
            }),  
            //删除发票日志
            fpDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/fpDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fp' ],
            }),  
            //修改发票日志
            fpUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/fpUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['fp'],
            }),  
            //发票日志列表
            fpList: build.query({
                query(user) {                    
                    return {
                        url: '/fpList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['fp'],
            }),   
            //新增往来账
            wlAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/wlAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['wl'], 
            }),   
            //删除往来账
            wlDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/wlDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['wl'], 
            }),              
            //往来账列表
            wlList: build.query({
                query(user) {                    
                    return {
                        url: '/wlList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['wl'],
            }),   
            //新增银行账
            zzAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/zzAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['zz'], 
            }),   
            //删除银行账
            zzDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/zzDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['zz'], 
            }),              
            //银行账列表
            zzList: build.query({
                query(user) {                    
                    return {
                        url: '/zzList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['zz'],
            }),   
            //新增团队报账单审批节点
            TDspjdAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspjdAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDspjd','baozhangdan'],
            }),  
            //修改保存团队报账单审批节点
            TDspjdUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspjdUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDspjd','baozhangdan'],
            }),  
            //删除团队报账单审批节点
            TDspjdDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspjdDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDspjd','baozhangdan'],
            }),  
            //批量删除团队报账单审批节点
            TDspjdPLDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspjdPLDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDspjd','baozhangdan'],
            }),  
             //团队报账单审批节点列表
             TDspjdList: build.query({
                query(user) {                    
                    return {
                        url: '/TDspjdList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['TDspjd'],
            }),  

            //新增收款单审批节点
            SKspjdAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKspjdAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKspjd','baozhangdan'],
            }),  
            //修改保存收款单审批节点
            SKspjdUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKspjdUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKspjd','baozhangdan'],
            }),  
            //删除收款单审批节点
            SKspjdDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKspjdDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKspjd','baozhangdan'],
            }),  
             //收款单审批节点修改
             SKspjdUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/SKspjdUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['SKspjd','baozhangdan'],
            }),  


             //新增付款单审批节点
             FKspjdAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKspjdAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKspjd','baozhangdan'],
            }),  
            //修改保存付款单审批节点
            FKspjdUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKspjdUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKspjd','baozhangdan'],
            }),  
            //删除付款单审批节点
            FKspjdDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKspjdDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKspjd','baozhangdan'],
            }),  
             //付款单审批节点修改
             FKspjdUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/FKspjdUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['FKspjd','baozhangdan'],
            }),  

            //新增费用单审批节点
            FYspjdAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYspjdAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYspjd','baozhangdan'],
            }),  
            //修改保存费用单审批节点
            FYspjdUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYspjdUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYspjd','baozhangdan'],
            }),  
            //删除费用单审批节点
            FYspjdDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYspjdDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYspjd','baozhangdan'],
            }),  
             //费用单审批节点修改
             FYspjdUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/FYspjdUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['FYspjd','baozhangdan'],
            }),  
            //新增借款单审批节点
            JKspjdAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKspjdAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['JKspjd','baozhangdan'],
            }),  
            //修改保存借款单审批节点
            JKspjdUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKspjdUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['JKspjd','baozhangdan'],
            }),  
            //删除借款单审批节点
            JKspjdDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKspjdDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['JKspjd','baozhangdan'],
            }),  
             //借款单审批节点修改
             JKspjdUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/JKspjdUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['JKspjd','baozhangdan'],
            }),  
            //新增开票申请审批节点
            KPSQspjdAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQspjdAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQspjd','baozhangdan'],
            }),  
            //修改保存开票申请审批节点
            KPSQspjdUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQspjdUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQspjd','baozhangdan'],
            }),  
            //删除开票申请审批节点
            KPSQspjdDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQspjdDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQspjd','baozhangdan'],
            }),  
             //开票申请审批节点修改
             KPSQspjdUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/KPSQspjdUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['KPSQspjd','baozhangdan'],
            }),  
            //批量新增团队报账单审批节点
            TDspjdPLAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspjdPLAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDspjd','baozhangdan'],
            }),  
            //修改团队报账单审批节点
            TDspjdUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/TDspjdUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['TDspjd'],
            }),  
            
            //团队报账单常用客户
            getCYKHlist: build.query({
                query(user) {                    
                    return {
                        url: '/getCYKHlist',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan'],
            }),   
            //团队报账单常用产品
            getCYCPlist: build.query({
                query(user) {                    
                    return {
                        url: '/getCYCPlist',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan'],
            }),   
            //团队报账单常用部门
            getCYBMlist: build.query({
                query(user) {                    
                    return {
                        url: '/getCYBMlist',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan'],
            }),   
            //团队报账单常用店铺
            getCYDPlist: build.query({
                query(user) {                    
                    return {
                        url: '/getCYDPlist',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan'],
            }),   
            //新增团队报账单审批日志
            TDspAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),  
            //删除团队报账单审批日志
            TDspDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),  
            //批量删除团队报账单审批日志
            TDspPLDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspPLDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),  
            //批量修改团队报账单审批日志状态
            TDspPLUpdate: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspPLUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),  
            //团队报账单审批日志列表
            TDspList: build.query({
                query(user) {                    
                    return {
                        url: '/TDspList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['TDsp'],
            }), 
            //修改团队报账单审批日志
            TDspUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/TDspUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['TDsp'],
            }), 
            //修改保存团队报账单审批日志
            TDspUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),  
            //批量新增团队报账单审批日志
            TDspPLAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDspPLAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),
            //提交团队报账单
            TDtijiao: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDtijiao',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),
            //同意审批团队报账单
            TDtongyi: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDtongyi',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),
            //驳回团队报账单
            TDbohui: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDbohui',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),
            //抄送团队报账单
            TDchaosong: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDchaosong',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),
            //团队报账单修改审批日志
            TDupdatecontent: build.mutation({
                query(user) {                    
                    return {
                        url: '/TDupdatecontent',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['TDsp','baozhangdan'],
            }),
            //批量新增收款单审批节点
            SKspjdPLAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKspjdPLAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKspjd'],
            }),
            //批量删除收款单审批节点
            SKspjdPLDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKspjdPLDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKspjd'],
            }),
            //复制新增收款单审批节点
            SKspjdCOPY: build.mutation({
                query(user) {                    
                    return {
                        url: '/SKspjdCOPY',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['SKspjd'],
            }),
            //收款单审批节点列表
            SKspjdList: build.query({
                query(user) {                    
                    return {
                        url: '/SKspjdList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['SKspjd'],
            }),
            //批量新增付款单审批节点
            FKspjdPLAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKspjdPLAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKspjd'],
            }),
            //批量删除付款单审批节点
            FKspjdPLDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKspjdPLDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKspjd'],
            }),
            //复制新增付款单审批节点
            FKspjdCOPY: build.mutation({
                query(user) {                    
                    return {
                        url: '/FKspjdCOPY',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FKspjd'],
            }),
            //付款单审批节点列表
            FKspjdList: build.query({
                query(user) {                    
                    return {
                        url: '/FKspjdList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['FKspjd'],
            }),
            //批量新增费用单审批节点
            FYspjdPLAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYspjdPLAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYspjd'],
            }),
            //批量删除费用单审批节点
            FYspjdPLDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYspjdPLDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYspjd'],
            }),
            //复制新增费用单审批节点
            FYspjdCOPY: build.mutation({
                query(user) {                    
                    return {
                        url: '/FYspjdCOPY',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['FYspjd'],
            }),
            //费用单审批节点列表
            FYspjdList: build.query({
                query(user) {                    
                    return {
                        url: '/FYspjdList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['FYspjd'],
            }),
            //批量新增借款单审批节点
            JKspjdPLAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKspjdPLAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['JKspjd'],
            }),
            //批量删除借款单审批节点
            JKspjdPLDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKspjdPLDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['JKspjd'],
            }),
            //复制新增借款单审批节点
            JKspjdCOPY: build.mutation({
                query(user) {                    
                    return {
                        url: '/JKspjdCOPY',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['JKspjd'],
            }),
            //借款单审批节点列表
            JKspjdList: build.query({
                query(user) {                    
                    return {
                        url: '/JKspjdList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['JKspjd'],
            }),
            
            //批量新增开票申请审批节点
            KPSQspjdPLAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQspjdPLAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQspjd'],
            }),
            //批量删除开票申请审批节点
            KPSQspjdPLDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQspjdPLDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQspjd'],
            }),
            //复制新增开票申请审批节点
            KPSQspjdCOPY: build.mutation({
                query(user) {                    
                    return {
                        url: '/KPSQspjdCOPY',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['KPSQspjd'],
            }),
            //开票申请审批节点列表
            KPSQspjdList: build.query({
                query(user) {                    
                    return {
                        url: '/KPSQspjdList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['KPSQspjd'],
            }),
            //费用票登记列表
            fypdjList: build.query({
                query(user) {                    
                    return {
                        url: '/fypdjList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['fypdj'],
            }),
            //新增费用票登记
            fypdjAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/fypdjAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fypdj','feiyong'],
            }),
            //修改保存费用票登记
            fypdjUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/fypdjUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fypdj'],
            }),
            //删除费用票登记
            fypdjDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/fypdjDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['fypdj','feiyong'],
            }),
            //修改费用票登记
            fypdjUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/fypdjUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['fypdj'],
            }),
            //成本票登记列表
            cbpdjList: build.query({
                query(user) {                    
                    return {
                        url: '/cbpdjList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['cbpdj'],
            }),
            //新增成本票登记
            cbpdjAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/cbpdjAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['cbpdj','dingdanzhichu'],
            }),
            //修改保存成本票登记
            cbpdjUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/cbpdjUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['cbpdj'],
            }),
            //删除成本票登记
            cbpdjDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/cbpdjDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['cbpdj','dingdanzhichu'],
            }),
            //修改成本票登记
            cbpdjUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/cbpdjUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['cbpdj'],
            }),
            //报表/利润/部门统计表
            deptTJ: build.query({
                query(user) {                    
                    return {
                        url: '/deptTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['dept','dingdanshouru','dingdanzhichu','fy'],
            }),
            //报表/利润/计调统计表
            jdTJ: build.query({
                query(user) {                    
                    return {
                        url: '/jdTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['baozhangdan','dingdanshouru','dingdanzhichu','fy'],
            }),
            //报表/往来/客户明细
            khTJ: build.query({
                query(user) {                    
                    return {
                        url: '/khTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['jiekuan','dingdanshouru','dingdanzhichu','fy'],
            }),
            //报表/往来/客户汇总
            khTJ2: build.query({
                query(user) {                    
                    return {
                        url: '/khTJ2',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['jiekuan','dingdanshouru','dingdanzhichu','fy'],
            }),
             //报表/利润/客户统计
             khlrTJ: build.query({
                query(user) {                    
                    return {
                        url: '/khlrTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['kehu','dingdanshouru','dingdanzhichu','fy','baozhangdan'],
            }),
            //报表/利润/操作员统计
            uidlrTJ: build.query({
                query(user) {                    
                    return {
                        url: '/uidlrTJ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['user','dingdanshouru','dingdanzhichu','fy','baozhangdan'],
            }),
            //银行/待记账单据
            zzDZZ: build.query({
                query(user) {                    
                    return {
                        url: '/zzDZZ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['dingdanshouru','dingdanzhichu','fy','jiekuan'],
            }),
            //收款单/新增银行转账记录
            dingdanshouruYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru'],
            }),
            //收款单/删除银行转账记录
            dingdanshouruDELYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanshouruDELYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanshouru'],
            }),
            //付款单/新增银行转账记录
            dingdanzhichuYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu'],
            }),
            //付款单/删除银行转账记录
            dingdanzhichuDELYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/dingdanzhichuDELYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['dingdanzhichu'],
            }),
            //费用单/新增银行转账记录
            feiyongYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong'],
            }),
            //费用单/删除银行转账记录
            feiyongDELYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/feiyongDELYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['feiyong'],
            }),
            //借款单/新增银行转账记录
            jiekuanYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan'],
            }),
            //借款单/删除银行转账记录
            jiekuanDELYHZH:build.mutation({
                query(user) {                    
                    return {
                        url: '/jiekuanDELYHZH',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['jiekuan'],
            }),
            //银行转账流水
            zzYZZ: build.query({
                query(user) {                    
                    return {
                        url: '/zzYZZ',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['dingdanshouru','dingdanzhichu','fy','jiekuan'],
            }),
            //密码登录
            yonghuLogin: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuLogin',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),         
            //企业登录
            yonghuLoginSelect: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuLoginSelect',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),         
            //退出登录，清除设备码
            yonghuDelSheBei: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuDelSheBei',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),         
            //忘记密码获取验证码
            yonghuUpdateCode: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuUpdateCode',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),         
            //清除设备吗获取验证码
            shebeimaCode: build.mutation({
                query(user) {                    
                    return {
                        url: '/shebeimaCode',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),         
            //修改密码
            yonghuUpdateMiMa: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuUpdateMiMa',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }), 
            //新增企业用户
            yonghuAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yonghu'],
            }),         
            //修改保存企业用户
            yonghuUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yonghu'],
            }),         
            //查询企业用户
            yonghuList: build.query({
                query(user) {                    
                    return {
                        url: '/yonghuList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yonghu'],
            }),         
            //修改企业用户
            yonghuUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/yonghuUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yonghu'],
            }),                             
             //新增企业
            qiyeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiye'],
            }),         
            //修改保存企业
            qiyeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiye'],
            }),         
            //查询企业
            qiyeList: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiye'],
            }),         
            //修改企业
            qiyeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiye'],
            }),         
            
            //新增商品
            shangpinAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpin'],
            }),         
            //删除商品
            shangpinDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpin'],
            }),         
            //修改保存商品
            shangpinUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpin'],
            }),         
            //查询商品
            shangpinList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpin'],
            }),         
            //修改商品
            shangpinUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpin'],
            }),         
            //新增商品规格
            shangpinguigeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinguigeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinguige'],
            }),         
            //删除商品规格
            shangpinguigeDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinguigeDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinguige'],
            }),         
            //修改保存商品规格
            shangpinguigeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinguigeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinguige'],
            }),         
            //查询商品规格
            shangpinguigeList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinguigeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinguige'],
            }),         
            //修改商品规格
            shangpinguigeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinguigeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinguige'],
            }),         
            //新增商品费用报销
            shangpindingdanAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpindingdanAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpindingdan'],
            }),         
            //修改保存商品费用报销
            shangpindingdanUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpindingdanUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpindingdan'],
            }),         
            //删除商品费用报销
            shangpindingdanDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpindingdanDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpindingdan'],
            }),         
            //查询商品费用报销
            shangpindingdanList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpindingdanList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpindingdan'],
            }),         
            //修改商品费用报销
            shangpindingdanUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpindingdanUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpindingdan'],
            }),    
           //新增商品教程
            shangpinjiaochengAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinjiaocheng'],
            }),         
            //修改保存商品教程
            shangpinjiaochengUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinjiaocheng'],
            }),         
            //查询商品教程
            shangpinjiaochengList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinjiaocheng'],
            }),         
            //修改商品教程
            shangpinjiaochengUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinjiaocheng'],
            }),   
            //新增用户获取短信验证码
            yonghuAddCode: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuAddCode',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
            }),      
             //删除商品教程
            shangpinjiaochengDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinjiaocheng'],
            }), 
            
        }
    }
})

export const { 
    usePingtaiTypeAddMutation,
    usePingtaiTypeListQuery,
    usePingtaiTypeUpdateQuery,
    usePingtaiTypeUpdateSaveMutation,
    usePingtaiTypeDelMutation,
    useChanpinTypeAddMutation,
    useChanpinTypeListQuery,
    useChanpinTypeUpdateQuery,
    useChanpinTypeUpdateSaveMutation,
    useChanpinTypeDelMutation,
    useBaozhangdanAddMutation,
    useBaozhangdanListQuery,
    useBaozhangdanUpdateQuery,
    useBaozhangdanUpdateSaveMutation,
    useBaozhangdanZTXGMutation,
    useBaozhangdanDelMutation,
    useShouzhiAddMutation,
    useShouzhiListQuery,
    useShouzhiUpdateQuery,
    useShouzhiUpdateSaveMutation,
    useShouzhiDelMutation,
    useShouzhiAllDelMutation,
    useShouzhiSHMutation,
    useShouzhiDelSHMutation,
    usePingtaiTypeMonthTJQuery,
    useDsbzdKFMonthTJQuery,
    useDsbzdJDMonthTJQuery,
    useDsbzdZBMonthTJQuery,
    useChanpinTypeMonthTJQuery,
    useDsbzdMonthTJQuery,
    useDsbzdSHMonthTJQuery,
    usePingtaiCreateDateLiRunQuery,          
    useChanpinCreateDateLiRunQuery,
    useJidiaoCreateDateLiRunQuery,
    useKefuCreateDateLiRunQuery,
    useZhuboCreateDateLiRunQuery,
    useGetWDMonthLiRunQuery,  
    useGetCPMonthLiRunQuery,
    useGetKFMonthLiRunQuery,
    useGetJDMonthLiRunQuery,
    useGetZBMonthLiRunQuery,
    useBaozhangdanSHListQuery,
    useShouzhiDelUidSHMutation,
    useBaozhangdanUidListQuery,
    useBaozhangdanPTListQuery,
    useBaozhangdanJDListQuery,
    useBaozhangdanKFListQuery,
    useBaozhangdanZBListQuery,
    useBaozhangdanCWCHMutation,
    useShouzhiAllDelYSYFMutation,
    useShouzhiAllUpdateYSYFMutation,
    useShouzhiDelYSYFMutation,
    useYingshouyingfuAddMutation,
    useYingshouyingfuDelMutation,
    useYingshouyingfuListQuery,
    useYingshouyingfuUpdateQuery,
    useYingshouyingfuUpdateSaveMutation,
    useGetLiRunQuery,
    useBankAddMutation,
    useBankDelMutation,
    useBankListQuery,
    useBankUpdateQuery,
    useBankUpdateSaveMutation,
    useDingdanshouruAddMutation,
    useDingdanshouruDelMutation,    
    useDingdanshouruListQuery,
    useDingdanshouruUpdateQuery,
    useSKspListQuery,
    useSKtijiaoMutation,
    useSKaddtijiaoMutation,
    useSKtongyiMutation,
    useSKbohuiMutation,
    useSKchaosongMutation,
    useSKupdatecontentMutation,
    useDingdanshouruUpdateSaveMutation,
    useDingdanshouruZTXGMutation,
    useDingdanzhichuAddMutation,
    useDingdanzhichuDelMutation,    
    useDingdanzhichuListQuery,
    useDingdanzhichuUpdateQuery,    
    useDingdanzhichuUpdateSaveMutation,
    useDingdanzhichuZTXGMutation,
    useFKspListQuery,
    useFKaddtijiaoMutation,
    useFKtijiaoMutation,
    useFKtongyiMutation,
    useFKbohuiMutation,
    useFKchaosongMutation,
    useFKupdatecontentMutation,
    useGetCYlistQuery,
    useBumenAddMutation,
    useBumenDelMutation,
    useBumenListQuery,
    useBumenUpdateQuery,
    useBumenUpdateSaveMutation,
    useKehuAddMutation,
    useCsvFileMutation,
    useKehuDelMutation,
    useKehuListQuery,
    useKehuUpdateQuery,
    useKehuUpdateSaveMutation,
    useKehulxAddMutation,
    useKehulxDelMutation,
    useKehulxListQuery,
    useKehulxUpdateQuery,
    useKehulxUpdateSaveMutation,
    useKehuyhzhAddMutation,
    useKehuyhzhDelMutation,
    useKehuyhzhListQuery,
    useKehuyhzhUpdateQuery,
    useKehuyhzhUpdateSaveMutation,
    useKehukpxxAddMutation,
    useKehukpxxDelMutation,
    useKehukpxxListQuery,
    useKehukpxxUpdateQuery,
    useKehukpxxUpdateSaveMutation,
    useShoukuanlxAddMutation,
    useShoukuanlxDelMutation,
    useShoukuanlxListQuery,
    useShoukuanlxUpdateQuery,
    useShoukuanlxUpdateSaveMutation,
    useFukuanlxAddMutation,
    useFukuanlxDelMutation,
    useFukuanlxListQuery,
    useFukuanlxUpdateQuery,
    useFukuanlxUpdateSaveMutation,
    useFeiyongTypeAddMutation,
    useFeiyongTypeListQuery,
    useFeiyongTypeUpdateQuery,
    useFeiyongTypeUpdateSaveMutation,
    useFeiyongTypeDelMutation,
    useFeiyongAddMutation,
    useFeiyongListQuery,
    useFeiyongUpdateQuery,
    useFeiyongUpdateSaveMutation,
    useFeiyongDelMutation,
    useFeiyongZTXGMutation,
    useFYbohuiMutation,
    useFYtongyiMutation,
    useFYaddtijiaoMutation,
    useFYspListQuery,
    useFYchaosongMutation,
    useFYtijiaoMutation,
    useFYupdatecontentMutation,
    useJiekuanlxAddMutation,
    useJiekuanlxDelMutation,
    useJKaddtijiaoMutation,
    useJKupdatecontentMutation,
    useJKtijiaoMutation,
    useJKspListQuery,
    useJKchaosongMutation,
    useJKbohuiMutation,
    useJKtongyiMutation,
    useJiekuanlxListQuery,
    useJiekuanlxUpdateQuery,
    useJiekuanlxUpdateSaveMutation,
    useJiekuanAddMutation,
    useJiekuanUpdateSaveMutation,
    useJiekuanDelMutation,
    useJiekuanZTXGMutation,
    useJiekuanUpdateQuery,
    useJiekuanListQuery,
    useKhlxrAddMutation,
    useKhlxrUpdateSaveMutation,
    useKhlxrDelMutation,
    useKhlxrUpdateQuery,
    useKhlxrListQuery,
    useKaipiaolxAddMutation,
    useKaipiaolxDelMutation,
    useKaipiaolxListQuery,
    useKaipiaolxUpdateQuery,
    useKaipiaolxUpdateSaveMutation,
    useKaipiaodanAddMutation,
    useKaipiaodanDelMutation,
    useKaipiaodanListQuery,
    useKaipiaodanUpdateQuery,
    useKaipiaodanUpdateSaveMutation,
    useKaipiaodanZTXGMutation,
    useKaipiaodanSCMutation,
    useKPSQspListQuery,
    useKPSQtijiaoMutation,
    useKPSQaddtijiaoMutation,
    useKPSQtongyiMutation,
    useKPSQbohuiMutation,
    useKPSQchaosongMutation,
    useKPSQupdatecontentMutation,
    useYueduAddMutation,
    useYueduDelMutation,
    useYueduListQuery,
    useQiyeyhzhAddMutation,
    useQiyeyhzhDelMutation,
    useQiyeyhzhListQuery,
    useQiyeyhzhUpdateQuery,
    useQiyeyhzhUpdateSaveMutation,
    useFpAddMutation,
    useFpUpdateSaveMutation,
    useFpDelMutation,
    useFpUpdateQuery,
    useFpListQuery,
    useWlAddMutation,
    useWlDelMutation,
    useWlListQuery,
    useZzAddMutation,
    useZzDelMutation,
    useZzListQuery,
    useTDspjdAddMutation,
    useTDspjdUpdateSaveMutation,
    useTDspjdDelMutation,
    useTDspjdPLDelMutation,
    useTDspjdPLAddMutation,
    useTDspjdUpdateQuery,
    useTDspjdListQuery,
    useTDtijiaoMutation,
    useTDtongyiMutation,
    useTDbohuiMutation,
    useTDchaosongMutation,
    useTDupdatecontentMutation,
    useGetCYKHlistQuery,
    useGetCYCPlistQuery,
    useGetCYBMlistQuery,
    useGetCYDPlistQuery,
    useTDspAddMutation,
    useTDspDelMutation,
    useTDspListQuery,
    useTDspUpdateQuery,
    useTDspUpdateSaveMutation,
    useTDspPLAddMutation,
    useTDspPLDelMutation,
    useTDspPLUpdateMutation,
    useSKspjdPLAddMutation,
    useSKspjdPLDelMutation,
    useSKspjdCOPYMutation,
    useSKspjdListQuery,
    useFKspjdPLAddMutation,
    useFKspjdPLDelMutation,
    useFKspjdCOPYMutation,
    useFKspjdListQuery,
    useFYspjdPLAddMutation,
    useFYspjdPLDelMutation,
    useFYspjdCOPYMutation,
    useFYspjdListQuery,
    useJKspjdPLAddMutation,
    useJKspjdPLDelMutation,
    useJKspjdCOPYMutation,
    useJKspjdListQuery,
    useKPSQspjdPLAddMutation,
    useKPSQspjdPLDelMutation,
    useKPSQspjdCOPYMutation,
    useKPSQspjdListQuery,
    useFypdjListQuery,
    useFypdjAddMutation,
    useFypdjUpdateSaveMutation,
    useFypdjDelMutation,
    useFypdjUpdateQuery,
    useCbpdjListQuery,
    useCbpdjAddMutation,
    useCbpdjUpdateSaveMutation,
    useCbpdjDelMutation,
    useCbpdjUpdateQuery,
    useDeptTJQuery,
    useJdTJQuery,
    useKhTJQuery,
    useDingdanshouruCWCHMutation,
    useDingdanzhichuCWCHMutation,
    useFeiyongCWCHMutation,
    useJiekuanCWCHMutation,
    useKaipiaodanCWCHMutation,
    useDingdanshouruZFLXMutation,
    useDingdanzhichuZFLXMutation,
    useFeiyongZFLXMutation,
    useKhlrTJQuery,
    useUidlrTJQuery,
    useKhTJ2Query,
    useSKspjdAddMutation,
    useSKspjdUpdateSaveMutation,
    useSKspjdDelMutation,
    useSKspjdUpdateQuery,
    useFKspjdAddMutation,
    useFKspjdUpdateSaveMutation,
    useFKspjdDelMutation,
    useFKspjdUpdateQuery,
    useFYspjdAddMutation,
    useFYspjdUpdateSaveMutation,
    useFYspjdDelMutation,
    useFYspjdUpdateQuery,
    useJKspjdAddMutation,
    useJKspjdUpdateSaveMutation,
    useJKspjdDelMutation,
    useJKspjdUpdateQuery,    
    useKPSQspjdAddMutation,
    useKPSQspjdUpdateSaveMutation,
    useKPSQspjdDelMutation,
    useKPSQspjdUpdateQuery,
    useZzDZZQuery,
    useDingdanshouruYHZHMutation,
    useDingdanzhichuYHZHMutation,
    useFeiyongYHZHMutation,
    useDingdanshouruDELYHZHMutation,
    useDingdanzhichuDELYHZHMutation,
    useFeiyongDELYHZHMutation,
    useJiekuanYHZHMutation,
    useJiekuanDELYHZHMutation,
    useZzYZZQuery,
    useYonghuLoginMutation,   
    useYonghuLoginSelectMutation,
    useYonghuUpdateCodeMutation,
    useShebeimaCodeMutation,
    useYonghuUpdateMiMaMutation,
    useYonghuAddMutation,
    useYonghuUpdateSaveMutation,
    useYonghuListQuery,
    useYonghuUpdateQuery,
    useYonghuDelSheBeiMutation,
    useShangpinAddMutation,
    useShangpinDelMutation,
    useShangpinUpdateSaveMutation,
    useShangpinListQuery,
    useShangpinUpdateQuery,
    useShangpinguigeAddMutation,
    useShangpinguigeDelMutation,
    useShangpinguigeUpdateSaveMutation,
    useShangpinguigeListQuery,
    useShangpinguigeUpdateQuery,
    useShangpindingdanAddMutation,
    useShangpindingdanUpdateSaveMutation,
    useShangpindingdanListQuery,
    useShangpindingdanDelMutation,
    useShangpindingdanUpdateQuery,
    useQiyeAddMutation,
    useQiyeUpdateSaveMutation,
    useQiyeListQuery,
    useQiyeUpdateQuery,
    useShangpinjiaochengAddMutation,
    useShangpinjiaochengDelMutation,
    useShangpinjiaochengListQuery,
    useShangpinjiaochengUpdateQuery,
    useShangpinjiaochengUpdateSaveMutation,
    useYonghuAddCodeMutation,
} = DianShangYeWuApi;
export default DianShangYeWuApi;